export default "__VITE_ASSET__pQCByAPz__"